import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

export const PageHeader = ({ eyebrow, title, description, breadcrumb = [] }) => {
  return (
    <section
      data-testid="page-header"
      className="relative overflow-hidden border-b border-slate-200 bg-gradient-to-br from-white via-slate-50 to-sky-50/40"
    >
      <div className="absolute inset-0 bg-grid-lines opacity-40" />
      <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-sky-100/40 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
        {breadcrumb.length > 0 && (
          <nav
            data-testid="page-header-breadcrumb"
            className="flex items-center gap-1 text-xs uppercase tracking-widest text-slate-500 mb-6"
          >
            {breadcrumb.map((b, i) => (
              <span key={`${b.label}-${i}`} className="flex items-center gap-1">
                {b.to ? (
                  <Link to={b.to} className="hover:text-[#0B1B3D]">
                    {b.label}
                  </Link>
                ) : (
                  <span className="text-slate-700">{b.label}</span>
                )}
                {i < breadcrumb.length - 1 && (
                  <ChevronRight className="w-3 h-3 text-slate-400" />
                )}
              </span>
            ))}
          </nav>
        )}

        {eyebrow && (
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-amber-600 font-medium mb-4">
            <span className="w-6 h-px bg-amber-500" /> {eyebrow}
          </div>
        )}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-[#0B1B3D] max-w-4xl leading-[1.05]">
          {title}
        </h1>
        {description && (
          <p className="mt-6 text-base lg:text-lg text-slate-600 max-w-2xl leading-relaxed">
            {description}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageHeader;
